export default "__VITE_ASSET__BLEKkTT___"